export const ApiInquiries = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const find = async (id, type) => {
    const result = await axios.get(`/api/inquiries/${type}/${id}`)
    return result.data
  }

  const points = async (id, type) => {
    const result = await axios.get('/api/inquiries/points')
    return result.data
  }

  const load = async (type, page = 1) => {
    const result = await axios.get(`/api/inquiries/${type}?page=${page}`)
    return result.data
  }

  const setStatus = async (id, status, type) => {
    const result = await axios.get(`/api/inquiries/${type}/${id}/status/${status}`)
    return result.data
  }

  const saveAndSendAnswer = async (type, hid, payload, shouldSend) => {
    const result = await axios.post(`/api/inquiries/${type}/${hid}/answer/${shouldSend}`, payload)
    return result.data
  }

  const resend = async (type, hid, mailId) => {
    const result = await axios.post(`/api/inquiries/${type}/${hid}/resend/${mailId}`)
    return result.data
  }

  const batch = async (type, action, payload) => {
    const result = await axios.post(`/api/inquiries/${type}/batch/${action}`, payload)
    return result.data
  }

  const discardAnswer = async (type, hid) => {
    const result = await axios.delete(`/api/inquiries/${type}/${hid}/answer/`)
    return result.data
  }

  return {
    inquiriesDiscardAnswer: discardAnswer,
    inquiriesFind: find,
    inquiriesLoad: load,
    inquiriesPoints: points,
    inquiriesBatch: batch,
    inquiriesResendAnswer: resend,
    inquiriesSetStatus: setStatus,
    inquiriesSaveAndSendAnswer: saveAndSendAnswer
  }
}
